import { Grid, Divider } from "@mui/material";
import { FC } from "react";
import { List, ListItem } from "@mui/material";
import { H4 } from "components/Typography";

interface FundHouseInformationProps {
  item: {
    metadata: any;
    general_info: any;
  };
}

const FundHouseInformation: FC<FundHouseInformationProps> = ({ item }) => {
  const data = [
    {
      name: "",
      value: item?.metadata?.objective ?? "",
    },
  ];
  const handleUrlClick = (url: string) => {
    window.open(url, "_blank");
  };
  return (
    <>
      <List>
        {data?.map((data, index) => (
          <>
            <ListItem
              disableGutters
              sx={{
                mt: 2,
                mb: 1,
                p: 1,
              }}
            >
              <H4>{data.value}</H4>
            </ListItem>
            <Divider />
          </>
        ))}
      </List>
      <Grid
        sx={{
          mb: 4,
          p: 1,
          cursor: "pointer",
        }}
        onClick={() => handleUrlClick(item?.general_info?.scheme_docs)}
      >
        <H4 fontWeight={500} fontSize={16}>
          VIEW SCHEME DOCUMENTATION
        </H4>
      </Grid>
    </>
  );
};

export default FundHouseInformation;
